import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/**
 * Servicio para controlar el Loader,
 * permite mostrar y ocultar el Loader.
 *
 * Ver tambien: LoaderComponent
 */
@Injectable()
export class LoaderService {
  private loadingSource = new BehaviorSubject<boolean>(false);
  public  isLoading = this.loadingSource.asObservable();
  private req = 0; // Contador de Requests

  /**
   * Muestra el Loader
   */
  mostrarLoader() {
    this.req++;
    if (this.req === 1) { // req > 1 => ya tengo el loader visible
      this.loadingSource.next(true);
    }
  }

  /**
   * Oculta el Loader
   */
  ocultarLoader() {
    this.req--;
    if (this.req === 0) { // cuando ya no tengo mas requests, oculto el laoder
      this.loadingSource.next(false);
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/loader.service.ts